import React from "react";

const UploadFailedModal = ({ handleCloseFailedModal }) => {
  return (
    <div
      className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 px-4"
      role="dialog"
      aria-labelledby="upload-failed-title"
      aria-modal="true"
    >
      <div className="bg-white w-full max-w-sm md:max-w-md p-6 rounded-lg shadow-lg text-center">
        <div className="w-20 h-20 bg-[#FFE0E0] rounded-full flex items-center justify-center mx-auto">
          <img src="/red-cross.png" alt="Red Cross" className="w-12 h-12" />
        </div>

        <h2 id="upload-failed-title" className="text-black text-lg font-semibold mt-4">
          File Not Uploaded!
        </h2>
        <p className="text-black text-sm mt-2">
          Sorry, we could not upload your file.
        </p>

        <button
          className="bg-[#005C53] text-white w-full max-w-xs h-12 rounded-lg mt-5"
          onClick={handleCloseFailedModal}
        >
          Close
        </button>
      </div>
    </div>
  );
};

export default UploadFailedModal;
